<div class="card">
    <div class="card-header">
        Reset Attendence
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Type:</label>
            </div>
            <div class="col px-1">
                <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Front"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Front
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Back"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Back
                </label>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Code:<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 px-1">
                <input name="Employeecode" [(ngModel)]="EmployeeCode" type="text" class="form-control"
                    (keypress)="onKeyPress($event)" placeholder="Enter Code" />
            </div>
            <div class="col-md-2 px-1">
                <!-- <button class="btn btn-sm btn-primary" name="Search" (click)="Search()"><i class="bi bi-search"></i>
                    Search
                </button> -->
                <button class="btn btn-sm btn-primary" name="submit" (click)="Search()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
        <hr>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Branch Name</th>
                                <th scope="col" *ngIf="EmployeeType === 'Front'">Site Name</th>
                                <th scope="col" style="display: none;">Employee Master ID</th>
                                <th scope="col">Employee Code</th>
                                <th scope="col">Employee Name</th>
                                <th scope="col" style="display: none;">Daily Attendence IN Out ID</th>
                                <th scope="col">Attendence Date</th>
                                <th scope="col">Check In</th>
                                <th scope="col">Check Out</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of EmployeeAttendenceData; let i = index">
                                <th scope="row">{{ i + 1 }}</th>
                                <td>{{ site['Branch'] }}</td>
                                <td *ngIf="EmployeeType === 'Front'">{{ site['Site'] }}</td>
                                <td style="display: none;">{{ site['EmpMasterID'] }}</td>
                                <td>{{ site['EmpCode'] }}</td>
                                <td>{{ site['FullName'] }}</td>
                                <td style="display: none;">{{ site['DailyAttendanceInOutID'] }}</td>
                                <td>{{ site['AttendanceDate'] }}</td>
                                <td>{{ site['InTime'] }}</td>
                                <td>{{ site['OutTime'] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsDelete" class="btn btn-sm btn-danger disabled-to-grey"
                    name="delete" (click)="delete()" [disabled]="OutTime !== null">
                    <i class="bi bi-trash-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Delete':'Loading...'}}
                </button>
                &nbsp;
                <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary disabled-to-grey"
                    name="checkout" (click)="Checkout()" [disabled]="OutTime !== null">
                    <i class="bi bi-clock" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Check Out':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>